import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Divider, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Language, Twitter, Instagram, YouTube, Telegram, MusicNote, LiveTv, Groups, SupportAgent } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import trendLogo from '../../assets/images/logo.png';

const Footer = () => {
    const theme = useTheme();

    return (
        <Box sx={{
            bgcolor: theme.palette.mode === 'dark' ? '#000' : '#f8fafc',
            py: 8,
            borderTop: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.08)',
            position: 'relative'
        }}>
            <Container maxWidth="xl">
                <Grid container spacing={4} justifyContent="space-between" alignItems="center">
                    <Grid item xs={12} md={4}>
                        <Box component="img" src={trendLogo} sx={{ width: '160px', mb: 3, filter: 'hue-rotate(40deg) drop-shadow(0 0 2px rgba(0, 240, 255, 0.5))' }} />
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, lineHeight: 1.8 }}>
                            Connecting the Web3 world through decentralized advertising. Transparent, efficient, and rewarding for everyone.
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'center' } }}>
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary, mb: 2, fontWeight: 700 }}>Socials</Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: { xs: 'flex-start', md: 'center' } }}>
                            {[
                                { name: 'Website', url: 'https://trendcreator.io/', color: '#00dff8', icon: <Language /> },
                                { name: 'Twitter', url: 'https://x.com/aitrendcreator', color: '#1DA1F2', icon: <Twitter /> },
                                { name: 'Instagram', url: 'https://www.instagram.com/trendcreatorai/', color: '#E1306C', icon: <Instagram /> },
                                { name: 'TikTok', url: 'https://www.tiktok.com/@trendcreatorai', color: '#fff', icon: <MusicNote /> },
                                { name: 'YouTube', url: 'https://www.youtube.com/@TrendCreatorai', color: '#FF0000', icon: <YouTube /> },
                                { name: 'Vimeo', url: 'https://vimeo.com/trendcreatorai', color: '#1AB7EA', icon: <LiveTv /> },
                                { name: 'Telegram Channel', url: 'https://t.me/trendcreatorai', color: '#0088cc', icon: <Telegram /> },
                            ].map((social) => (
                                <IconButton
                                    key={social.name}
                                    onClick={() => window.open(social.url, '_blank')}
                                    title={social.name}
                                    sx={{
                                        bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                        color: theme.palette.text.primary,
                                        '&:hover': { bgcolor: social.color, transform: 'translateY(-2px)' },
                                        transition: 'all 0.3s'
                                    }}
                                >
                                    {social.icon}
                                </IconButton>
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary, mb: 2, fontWeight: 700 }}>Legal</Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                component={RouterLink}
                                to="/terms"
                                underline="hover"
                                sx={{ color: theme.palette.text.secondary, '&:hover': { color: theme.palette.primary.main } }}
                            >
                                Terms of Service
                            </Link>
                            <Link
                                component={RouterLink}
                                to="/privacy"
                                underline="hover"
                                sx={{ color: theme.palette.text.secondary, '&:hover': { color: theme.palette.primary.main } }}
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                component={RouterLink}
                                to="/disclaimer"
                                underline="hover"
                                sx={{ color: theme.palette.text.secondary, '&:hover': { color: theme.palette.primary.main } }}
                            >
                                Disclaimer
                            </Link>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.08)', my: 6 }} />

                <Typography variant="body2" align="center" sx={{ color: theme.palette.text.secondary, opacity: 0.6 }}>
                    &#169; {new Date().getFullYear()} Trend Ads. All rights reserved.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
